import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import TauriBreadCrumbDropdown from "../TauriBreadcrumbDropdown";

const TauriMonthAndYearDropdown = ({ onDateChange }) => {
  const cyclePeriods = [
    "CP1",
    "CP2",
    "CP3",
    "CP4",
    "CP5",
    "CP6",
    "CP7",
    "CP8",
    "CP9",
    "CP10",
    "CP11",
    "CP12",
    "CP13",
  ];

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();
  const numberOfYears = 2;

  const years = [];
  for (let i = currentYear - numberOfYears; i <= currentYear; i++) {
    years.push(i);
  }

  const getInitialValue = (key, defaultValue) =>
    parseInt(localStorage.getItem(key), 10) || defaultValue;

  const getFullYear = (date) => new Date(date).getFullYear();

  const cyclePeriodCode = getInitialValue(
    "c_cd",
    cyclePeriods[currentMonthIndex],
  );

  const cyclePeriodFromYear = getFullYear(localStorage.getItem("c_str"));
  const cyclePeriodToYear = getFullYear(localStorage.getItem("c_end"));

  const [selectedDates, setSelectedDates] = useState({
    FromMonth: getInitialValue("FromMonth", cyclePeriodCode),
    FromYear: getInitialValue("FromYear", cyclePeriodFromYear),
    ToMonth: getInitialValue("ToMonth", cyclePeriodCode),
    ToYear: getInitialValue("ToYear", cyclePeriodToYear),
  });

  useEffect(() => {
    localStorage.setItem("FromMonth", selectedDates.FromMonth);
    localStorage.setItem("FromYear", selectedDates.FromYear);
    localStorage.setItem("ToMonth", selectedDates.ToMonth);
    localStorage.setItem("ToYear", selectedDates.ToYear);
    onDateChange({
      FromMonth: selectedDates.FromMonth,
      FromYear: selectedDates.FromYear,
      ToMonth: selectedDates.ToMonth,
      ToYear: selectedDates.ToYear,
    });
  }, [selectedDates]);

  useEffect(() => {
    onDateChange(selectedDates);
  }, []);

  const cyclePeriodItems = cyclePeriods.map((cyclePeriod) => ({
    label: cyclePeriod.toString(),
    value: cyclePeriod,
  }));

  const yearItems = years.map((year) => ({
    label: year.toString(),
    value: year,
  }));

  return (
    <>
      <div className="label-date mx-1">From</div>
      <TauriBreadCrumbDropdown
        items={cyclePeriodItems}
        onSelect={(cyclePeriod) =>
          setSelectedDates((prev) => ({ ...prev, FromMonth: cyclePeriod }))
        }
        selectedItem={selectedDates.FromMonth}
        variant="secondary"
        id="monthDropdown"
        className="mr-3"
        placeholder="--Select Cycle Period--"
      />

      <TauriBreadCrumbDropdown
        items={yearItems}
        onSelect={(year) =>
          setSelectedDates((prev) => ({ ...prev, FromYear: year }))
        }
        selectedItem={selectedDates.FromYear}
        variant="secondary"
        id="yearDropdown"
        className="mr-3"
        placeholder="--Select Year--"
      />

      <div className="label-date mx-1">To</div>

      <TauriBreadCrumbDropdown
        items={cyclePeriodItems}
        onSelect={(cyclePeriod) =>
          setSelectedDates((prev) => ({ ...prev, ToMonth: cyclePeriod }))
        }
        selectedItem={selectedDates.ToMonth}
        variant="secondary"
        id="toMonthDropdown"
        className="mr-3"
        placeholder="--Select Cycle Period--"
      />

      <TauriBreadCrumbDropdown
        items={yearItems}
        onSelect={(year) =>
          setSelectedDates((prev) => ({ ...prev, ToYear: year }))
        }
        selectedItem={selectedDates.ToYear}
        variant="secondary"
        id="toYearDropdown"
        className="mr-3"
        placeholder="--Select Year--"
      />
    </>
  );
};
export default TauriMonthAndYearDropdown;
